<script setup>
  import {MedButton} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "ComponentDemodataDialogSelectableDemocase",
  });

  defineProps({
    demodataId: {
      type: Number,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    disease: {
      type: String,
      required: true,
    },
    imgSrc: {
      type: [String, Object],
      required: true,
    },
  });

  defineEmits(["select"]);
</script>

<template>
  <MedButton
    flat
    variant="default"
    class="group block text-center"
    :data-test="getTestId('button-button')"
    @click="$emit('select', demodataId)"
  >
    <template #default>
      <span class="inline-flex size-16 items-center justify-center">
        <img :src="imgSrc" alt="Avatar" class="size-full rounded-full" />
      </span>

      <span class="mt-1.5 block text-mcblue">{{ name }}</span>
      <span class="mt-0.5 block font-light text-mcblue">{{ disease }}</span>
    </template>
  </MedButton>
</template>
